import { useDispatch, useSelector } from 'react-redux'
import { RootState, TypedDispatch } from 'redux/store'
import orderDesignationSlice from './order-designation-slice'
import { OrderDesignationSliceValue } from './order-designation-types'
import { useMemo } from 'react'
import { updateTransactionDesignation } from '../../../../redux/services/transaction'

const useOrderDesignation = () => {
  const dispatch = useDispatch<TypedDispatch<RootState>>()
  const state = useSelector((state: RootState) => state.order.designation)

  const { confirmationId, confirmationToken } = useSelector(
    (state: RootState) => state.order.transaction,
  )

  return useMemo(
    () => ({
      value: state.value,
      setValue: (value: OrderDesignationSliceValue) => {
        dispatch(orderDesignationSlice.actions.setValue(value))
      },
      save: (value: OrderDesignationSliceValue) => {
        if (!confirmationToken) return

        dispatch(
          updateTransactionDesignation.initiate({
            transactionId: String(confirmationId),
            transactionToken: confirmationToken,
            transactionDesignation: {
              designation_id: Number(value.designationId),
            },
          }),
        )
      },
    }),
    [confirmationId, dispatch, state.value, confirmationToken],
  )
}

export default useOrderDesignation
